import script from "./VocabularyItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VocabularyItem.vue?vue&type=script&setup=true&lang=js"

import "./VocabularyItem.vue?vue&type=style&index=0&id=09cfa0c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09cfa0c4"]])

export default __exports__